import { Module } from './module-enum';

export class OxygenCalibration {
  deviceId: number;
  name: string;
  saveLocationName: string;
  temperatureControlA?: boolean;
  temperatureControlB?: boolean;
  temperatureControlC?: boolean;
  temperatureControlD?: boolean;
  inputTemperatureA?: number;
  inputTemperatureB?: number;
  inputTemperatureC?: number;
  inputTemperatureD?: number;
  isZeroPercent?: boolean;
  is100Percent?: boolean;
  temperature_0_A?: number;
  temperature_0_B?: number;
  temperature_0_C?: number;
  temperature_0_D?: number;
  temperature_100_A?: number;
  temperature_100_B?: number;
  temperature_100_C?: number;
  temperature_100_D?: number;
  pressure_100_A?: number;
  pressure_100_B?: number;
  pressure_100_C?: number;
  pressure_100_D?: number;
  dphi_0_A?: number;
  dphi_0_B?: number;
  dphi_0_C?: number;
  dphi_0_D?: number;
  dphi_100_A?: number;
  dphi_100_B?: number;
  dphi_100_C?: number;
  dphi_100_D?: number;
  hasError_0_A?: boolean;
  hasError_0_B?: boolean;
  hasError_0_C?: boolean;
  hasError_0_D?: boolean;
  hasError_100_A?: boolean;
  hasError_100_B?: boolean;
  hasError_100_C?: boolean;
  hasError_100_D?: boolean;
  id?: number;
  isFinal?: boolean;
  laboratoryId?: number;
  createdAt?: Date;
  isDeleted?: boolean;
  deviceName?: string;
  calibrationType?: Module;
  notes?: string;
  createdBy?: string;
  notificationEmail?: string;

  constructor(
    deviceId: number,
    name: string,
    saveLocationName: string,
    temperatureControlA?: boolean,
    temperatureControlB?: boolean,
    temperatureControlC?: boolean,
    temperatureControlD?: boolean,
    inputTemperatureA?: number,
    inputTemperatureB?: number,
    inputTemperatureC?: number,
    inputTemperatureD?: number,
    isZeroPercent?: boolean,
    is100Percent?: boolean,
    temperature_0_A?: number,
    temperature_0_B?: number,
    temperature_0_C?: number,
    temperature_0_D?: number,
    temperature_100_A?: number,
    temperature_100_B?: number,
    temperature_100_C?: number,
    temperature_100_D?: number,
    pressure_100_A?: number,
    pressure_100_B?: number,
    pressure_100_C?: number,
    pressure_100_D?: number,
    dphi_0_A?: number,
    dphi_0_B?: number,
    dphi_0_C?: number,
    dphi_0_D?: number,
    dphi_100_A?: number,
    dphi_100_B?: number,
    dphi_100_C?: number,
    dphi_100_D?: number,
  ) {
    this.deviceId = deviceId;
    this.name = name;
    this.saveLocationName = saveLocationName;
    this.temperatureControlA = temperatureControlA;
    this.temperatureControlB = temperatureControlB;
    this.temperatureControlC = temperatureControlC;
    this.temperatureControlD = temperatureControlD;
    this.inputTemperatureA = inputTemperatureA;
    this.inputTemperatureB = inputTemperatureB;
    this.inputTemperatureC = inputTemperatureC;
    this.inputTemperatureD = inputTemperatureD;
    this.isZeroPercent = isZeroPercent;
    this.is100Percent = is100Percent;
    this.temperature_0_A = temperature_0_A;
    this.temperature_0_B = temperature_0_B;
    this.temperature_0_C = temperature_0_C;
    this.temperature_0_D = temperature_0_D;
    this.temperature_100_A = temperature_100_A;
    this.temperature_100_B = temperature_100_B;
    this.temperature_100_C = temperature_100_C;
    this.temperature_100_D = temperature_100_D;
    this.pressure_100_A = pressure_100_A;
    this.pressure_100_B = pressure_100_B;
    this.pressure_100_C = pressure_100_C;
    this.pressure_100_D = pressure_100_D;
    this.dphi_0_A = dphi_0_A;
    this.dphi_0_B = dphi_0_B;
    this.dphi_0_C = dphi_0_C;
    this.dphi_0_D = dphi_0_D;
    this.dphi_100_A = dphi_100_A;
    this.dphi_100_B = dphi_100_B;
    this.dphi_100_C = dphi_100_C;
    this.dphi_100_D = dphi_100_D;
  }
}

export class OxygenCalibrationUpdate {
  name: string;
  temperature_0_A?: number;
  temperature_0_B?: number;
  temperature_0_C?: number;
  temperature_0_D?: number;
  temperature_100_A?: number;
  temperature_100_B?: number;
  temperature_100_C?: number;
  temperature_100_D?: number;
  pressure_100_A?: number;
  pressure_100_B?: number;
  pressure_100_C?: number;
  pressure_100_D?: number;
  dphi_0_A?: number;
  dphi_0_B?: number;
  dphi_0_C?: number;
  dphi_0_D?: number;
  dphi_100_A?: number;
  dphi_100_B?: number;
  dphi_100_C?: number;
  dphi_100_D?: number;
  id?: number;
  notes?: string;

  constructor(
    name: string,
    temperature_0_A?: number,
    temperature_0_B?: number,
    temperature_0_C?: number,
    temperature_0_D?: number,
    temperature_100_A?: number,
    temperature_100_B?: number,
    temperature_100_C?: number,
    temperature_100_D?: number,
    pressure_100_A?: number,
    pressure_100_B?: number,
    pressure_100_C?: number,
    pressure_100_D?: number,
    dphi_0_A?: number,
    dphi_0_B?: number,
    dphi_0_C?: number,
    dphi_0_D?: number,
    dphi_100_A?: number,
    dphi_100_B?: number,
    dphi_100_C?: number,
    dphi_100_D?: number,
    id?: number,
    notes?: string,
  ) {
    this.name = name;
    this.temperature_0_A = temperature_0_A;
    this.temperature_0_B = temperature_0_B;
    this.temperature_0_C = temperature_0_C;
    this.temperature_0_D = temperature_0_D;
    this.temperature_100_A = temperature_100_A;
    this.temperature_100_B = temperature_100_B;
    this.temperature_100_C = temperature_100_C;
    this.temperature_100_D = temperature_100_D;
    this.pressure_100_A = pressure_100_A;
    this.pressure_100_B = pressure_100_B;
    this.pressure_100_C = pressure_100_C;
    this.pressure_100_D = pressure_100_D;
    this.dphi_0_A = dphi_0_A;
    this.dphi_0_B = dphi_0_B;
    this.dphi_0_C = dphi_0_C;
    this.dphi_0_D = dphi_0_D;
    this.dphi_100_A = dphi_100_A;
    this.dphi_100_B = dphi_100_B;
    this.dphi_100_C = dphi_100_C;
    this.dphi_100_D = dphi_100_D;
    this.id = id;
    this.notes = notes;
  }
}
